import { sendGetRequest } from '@vh/services/PDService';
import { useEffect, useState } from 'react';

/** @type {() => string} */
const useGetDeepgramToken = () => {
  const [sttToken, setSttToken] = useState('');
  useEffect(() => {
    const getToken = async () => {
      let sttTokenResponse = await sendGetRequest('stt-token');
      setSttToken(sttTokenResponse?.data ?? '');
    };
    getToken();
  }, []);

  return sttToken;
};

export default useGetDeepgramToken;
